function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-73 -1336)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(73 1336)",
  strokeMiterlimit: 10,
  stroke: "#d3d3d3",
  fill: "#fff"
},
/*#__PURE__*/
React.createElement("rect", {
  width: 30,
  height: 20,
  rx: 2,
  stroke: "none"
}),
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 19,
  rx: 1.5,
  fill: "none"
})),
/*#__PURE__*/
React.createElement("circle", {
  cx: 5,
  cy: 5,
  r: 5,
  transform: "translate(83 1341)",
  fill: "#00857c"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M88.292 1343.694a.856.856 0 01.816.808h.6a1.428 1.428 0 00-1.413-1.4v-.606h-.348v.606a1.718 1.718 0 00-.782.244 1.424 1.424 0 00-.64 1.19 1.329 1.329 0 00.597 1.114 3.893 3.893 0 00.824.379v1.994a.89.89 0 01-.866-.873.107.107 0 01.008-.05h-.58a.832.832 0 00-.008.127 1.261 1.261 0 00.622 1.1 1.461 1.461 0 00.824.269v.782h.345v-.782a1.81 1.81 0 00.85-.269 1.443 1.443 0 00.673-1.22 1.414 1.414 0 00-.648-1.194 4.205 4.205 0 00-.875-.4zm-.345 1.683c-.572-.193-.816-.454-.816-.875 0-.446.286-.74.816-.808zm.345.8c.614.227.892.522.892.967a.879.879 0 01-.892.883z",
  stroke: "#fff",
  strokeWidth: 0.3,
  fill: "#fff"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.253 3.09h19.191a4.88 4.88 0 00.856 1.868 4.112 4.112 0 001.627 1.067v8.568a3.5 3.5 0 00-1.758.733A3.072 3.072 0 0024.443 17H5.253a2.916 2.916 0 00-.585-1.674 3.124 3.124 0 00-1.658-.733V6.025a3.706 3.706 0 001.392-1.067 6.114 6.114 0 00.851-1.868z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
  stroke: "#d3d3d3"
});

var SvgCashPayment = function SvgCashPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 30,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgCashPayment, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/CashPayment.d246ce0d.svg";
export { ForwardRef as ReactComponent };